let logos = $('.logos');
if (logos.length) {
  let timeout = parseInt(logos.data('timeout'));

  logos.find(".owl-carousel").owlCarousel({
    loop:true,
    responsiveClass:true,
    nav: false,
    autoplay:true,
    autoplayTimeout:timeout,
    autoplayHoverPause:false,
    responsive : {
      0: {
        items: 1,
      },
      768: {
        items: 3
      },
      1024: {
        items: 5
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/components/logos.js